import { useTranslation } from "react-i18next";
import type { PricingPlan } from "@/lib/pricingPlans";

/**
 * The small line under a plan card's price. A yearly card shows the monthly
 * equivalent ($29/month) in big type, so this line has to say what is charged
 * today: "Billed $348 yearly". The old "Billed annually" read as a $29 charge,
 * and buyers who picked Yearly by mistake asked for refunds (Aug 31, Sep 9,
 * Oct 6). The landing page's pricing section already showed the total.
 */
export default function PlanBillingNote({
  plan,
  billingPeriod,
}: {
  plan: Pick<PricingPlan, "id" | "yearlyPrice">;
  billingPeriod: "monthly" | "yearly";
}) {
  const { t } = useTranslation();
  if (plan.id === "free") return <>{t("pricing.free")}</>;
  if (billingPeriod === "yearly") {
    return (
      <>
        {t("pricing.billedYearly", {
          amount: plan.yearlyPrice.toLocaleString("en-US"),
        })}
      </>
    );
  }
  return <>{t("pricing.billedMonthly")}</>;
}
